import { __awaiter, __generator } from "tslib";
import types from '../types';
var reduxNoop = {
    type: types.NO_OP,
};
var GlobalUnreadsCountActionsDisabled = /** @class */ (function () {
    function GlobalUnreadsCountActionsDisabled() {
    }
    GlobalUnreadsCountActionsDisabled.prototype.isEnabled = function () { return false; };
    GlobalUnreadsCountActionsDisabled.prototype.enable = function () { return reduxNoop; };
    GlobalUnreadsCountActionsDisabled.prototype.updateChatroomIds = function () { return reduxNoop; };
    GlobalUnreadsCountActionsDisabled.prototype.markAsRead = function () { return reduxNoop; };
    GlobalUnreadsCountActionsDisabled.prototype.markAsUnread = function () { return reduxNoop; };
    return GlobalUnreadsCountActionsDisabled;
}());
var GlobalUnreadsCountActionsEnabled = /** @class */ (function () {
    function GlobalUnreadsCountActionsEnabled(config) {
        this.unreadChatroomsToFetch = config.maxTrackableUnreads + 1;
    }
    GlobalUnreadsCountActionsEnabled.prototype.enable = function () {
        return reduxNoop;
    };
    GlobalUnreadsCountActionsEnabled.prototype.isEnabled = function () {
        return true;
    };
    GlobalUnreadsCountActionsEnabled.prototype.updateChatroomIds = function (chatroomIds) {
        return {
            type: types.UPDATE_UNREAD_CHATROOMS,
            data: {
                chatroomIds: chatroomIds,
            },
        };
    };
    GlobalUnreadsCountActionsEnabled.prototype.markAsRead = function (chatroomId, resyncCallback) {
        var _this = this;
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            var resyncCountdown;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch({
                            type: types.MARK_CHATROOM_READ,
                            data: {
                                chatroomId: chatroomId,
                            }
                        })];
                    case 1:
                        _a.sent();
                        resyncCountdown = getState().globalUnreadsCount.resyncCountdown;
                        if (!(resyncCountdown === 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, resyncCallback({ unreadChatroomLimit: this.unreadChatroomsToFetch })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    };
    GlobalUnreadsCountActionsEnabled.prototype.markAsUnread = function (chatroomId) {
        return {
            type: types.MARK_CHATROOM_UNREAD,
            data: {
                chatroomId: chatroomId,
            }
        };
    };
    return GlobalUnreadsCountActionsEnabled;
}());
var GlobalUnreadsCountActionsWrapper = /** @class */ (function () {
    function GlobalUnreadsCountActionsWrapper(config) {
        this.instance = new GlobalUnreadsCountActionsDisabled();
        this.config = config;
    }
    GlobalUnreadsCountActionsWrapper.prototype.enable = function () {
        this.instance = new GlobalUnreadsCountActionsEnabled(this.config);
        return reduxNoop;
    };
    GlobalUnreadsCountActionsWrapper.prototype.isEnabled = function () {
        return this.instance.isEnabled();
    };
    GlobalUnreadsCountActionsWrapper.prototype.updateChatroomIds = function (chatroomIds) {
        return this.instance.updateChatroomIds(chatroomIds);
    };
    GlobalUnreadsCountActionsWrapper.prototype.markAsRead = function (chatroomId, resyncCallback) {
        return this.instance.markAsRead(chatroomId, resyncCallback);
    };
    GlobalUnreadsCountActionsWrapper.prototype.markAsUnread = function (chatroomId) {
        return this.instance.markAsUnread(chatroomId);
    };
    return GlobalUnreadsCountActionsWrapper;
}());
export default (function (config) {
    return new GlobalUnreadsCountActionsWrapper(config);
});
